import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MeasurementRoutes } from './measurement.routes';
import { MeasurementListComponent } from './pages/measurement-list/measurement-list.component';
import { MeasurementViewComponent } from './pages/measurement-view/measurement-view.component';
import { MeasurementImportComponent } from './pages/measurement-import/measurement-import.component';

const ROUTES: Routes = [
    { path: MeasurementRoutes.MeasurementList, component: MeasurementListComponent },
    { path: MeasurementRoutes.Measurement, component: MeasurementViewComponent },
    { path: MeasurementRoutes.MeasurementImport, component: MeasurementImportComponent }
];

@NgModule({
    imports: [RouterModule.forChild(ROUTES)],
    exports: [RouterModule]
})
export class MeasurementRoutingModule {}
